import ProfileInvite from './ProfileInvite.component';

export default ProfileInvite;
